import { useNavigate } from "react-router-dom";
import {useDispatch} from "react-redux"
import { deleteGenres } from "../store/actions";
import Swal from "sweetalert2"

export default function GenreRow({genre,i}){
const navigate= useNavigate()
const dispatch= useDispatch()

    const deleteGenre= (e,id)=>{
        e.preventDefault();
        dispatch(deleteGenres(id))
        Swal.fire({
            icon: 'success',
            title: 'Success delete genre'
        })
    }

    const editGenre= (e)=>{
        e.preventDefault()
        navigate(`/editGenre/${genre.id}`)
    }
    return(
    <tr className="bg-white border-b dark:bg-gray-900 dark:border-gray-700">
        <td className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
           {i+1}
        </td>
        <td className="py-4 px-6">
            {genre.name}
        </td>
        <td className="py-4 px-6">
            <button className="font-medium text-red-600 dark:text-red-500 hover:text-red-400" onClick={(e)=>deleteGenre(e,genre.id)}>Delete</button>
            <button className="font-medium text-blue-600 dark:text-blue-500 hover:text-blue-400 pl-5" onClick={editGenre}>Edit</button>
        </td>
    </tr>
    )
}